module.exports = __webpack_public_path__ + "static/media/Test3.011a9738.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/reportCards/Test3.png
// module id = 1218
// module chunks = 0